// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2yHpa","searchInput":"styles_searchInput__36Yxo","tags":"styles_tags__33JiN","newTag":"styles_newTag__2qKjJ","alert":"styles_alert__1WIXL"};